__turbopack_context__.v({
  "className": "ibm_plex_mono_76b68551-module__lerKhW__className",
  "variable": "ibm_plex_mono_76b68551-module__lerKhW__variable",
});
